import React from "react";
import "./style.scss";

class AppFooter extends React.Component {
  render() {
    return null;
  }
}

export default AppFooter;



// WEBPACK FOOTER //
// ./src/components/LayoutComponents/Footer/index.js